import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export function isListedForSale(account) {
  return account?.listed_for_sale === true;
}

export function getSaleListingUrl(account) {
  const url = account?.sale_listing_url;
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  return trimmed || null;
}

const BADGE_CLASSES =
  'bg-amber-100 text-amber-800 border border-amber-200 text-xs px-2 py-0.5 font-semibold inline-flex items-center gap-1';

function BadgeContent({ linked = false }) {
  return (
    <>
      For sale
      {linked && <ExternalLink className="w-3 h-3 shrink-0 opacity-70" aria-hidden="true" />}
    </>
  );
}

function openListingInNewTab(url, event) {
  event?.stopPropagation?.();
  event?.preventDefault?.();
  window.open(url, '_blank', 'noopener,noreferrer');
}

export default function ListedForSaleBadge({ account, url, className = '', stopPropagation = false }) {
  const listingUrl = url ?? getSaleListingUrl(account);

  if (listingUrl && stopPropagation) {
    return (
      <span
        role="link"
        tabIndex={0}
        onClick={(event) => openListingInNewTab(listingUrl, event)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            openListingInNewTab(listingUrl, event);
          }
        }}
        className={`${BADGE_CLASSES} cursor-pointer hover:underline ${className}`}
      >
        <BadgeContent linked />
      </span>
    );
  }

  if (listingUrl) {
    return (
      <a
        href={listingUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={`${BADGE_CLASSES} hover:underline ${className}`}
      >
        <BadgeContent linked />
      </a>
    );
  }

  return (
    <Badge className={`${BADGE_CLASSES} ${className}`}>
      For sale
    </Badge>
  );
}
